<template>
  <div :class="['center', bBottom ? '' : 'contentImg']">
    <div class="share_center" ref="shareWrap">
      <div class="detailinfo">
        <!-- 右上角标签 -->
        <!-- nocomplete  施工中 complete 已完成  contract  已签约  -->
        <div
          :class="[
            'badge',
            caseDetail.state == 1
              ? 'contract'
              : caseDetail.state == 2
              ? 'nocomplete'
              : caseDetail.state == 2
              ? 'complete'
              : '',
          ]"
        >
          {{ contractText }}
        </div>
        <div class="title">
          <!-- <span>{{ caseDetail.title }}</span> -->
          <div class="title_bef"></div>
          <span
            >{{ caseDetail.type ? caseDetail.type + " | " : ""
            }}{{ caseDetail.city ? caseDetail.city : ""
            }}{{
              caseDetail.community_name ? caseDetail.community_name : ""
            }}项目案例</span
          >
        </div>
        <div class="info-warp">
          <div class="date">
            <img src="~@/assets/images/ant/details/date_icon.png" alt="" />
            <div>{{ caseDetail.formatTime }}</div>
          </div>
          <div class="forward">
            <img src="~@/assets/images/ant/details/forward_icon.png" alt="" />
            <div>{{
              caseDetail.shares == 0
                ? caseDetail.real_shares
                : caseDetail.shares
            }}</div>
          </div>
          <div class="look">
            <img src="~@/assets/images/ant/details/look_icon.png" alt="" />
            <div>{{
              caseDetail.views == 0 ? caseDetail.real_views : caseDetail.views
            }}</div>
          </div>
        </div>
        <div class="setup">
          <ul>
            <li v-if="caseDetail.house_area != ''">
              <div>{{ caseDetail.house_area }}</div>
              <div>建筑面积</div>
            </li>
            <li
              v-if="
                caseDetail.house_type != '' && caseDetail.house_type_room != ''
              "
            >
              <div>
                {{ caseDetail.house_type
                }}{{
                  caseDetail.house_type_room ? caseDetail.house_type_room : ""
                }}
              </div>
              <div>房型</div>
            </li>
            <li v-if="caseDetail.house_cate != ''">
              <div>{{ caseDetail.house_cate }}</div>
              <div>房屋种类</div>
            </li>
            <li
              v-if="
                caseDetail.house_cate != '' ||
                caseDetail.house_area != '' ||
                caseDetail.house_type != '' ||
                caseDetail.house_type_room != ''
              "
            >
              <div>
                {{
                  caseDetail.quoted_price
                    ? caseDetail.quoted_price
                    : caseDetail.type
                }}
              </div>
              <div>{{ caseDetail.quoted_price ? "案例报价" : "案例类型" }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="detailinfo seatop"
        v-if="caseDetail.comments.length != 0 || !nPin"
      >
        <div v-if="!nPin">
          <div class="title">
            <div class="title_bef"></div>
            用户评价
          </div>
          <div class="star">
            <ul>
              <li class="design-list">
                <div class="designone">
                  <div class="designone_bef"></div>
                  方案设计
                </div>
                <div class="des-right">
                  <div class="straight">
                    <!-- list-nostar -->
                    <div
                      v-for="(item, index) in caseDetail.arrDesign"
                      :key="index"
                    >
                      <img
                        v-if="item == 'list-star'"
                        src="~@/assets/images/ant/details/star_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-nostar'"
                        src="~@/assets/images/ant/details/nostar_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-one'"
                        src="~@/assets/images/ant/details/xing_1.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-two'"
                        src="~@/assets/images/ant/details/xing_2.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-three'"
                        src="~@/assets/images/ant/details/xing_3.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-four'"
                        src="~@/assets/images/ant/details/xing_4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    {{
                      caseDetail.project_design == 0
                        ? "暂未评分"
                        : caseDetail.project_design
                        ? caseDetail.project_design + "分"
                        : ""
                    }}
                  </div>
                </div>
              </li>
              <li class="design-list">
                <div class="designtwo">
                  <div class="designtwo_bef"></div>
                  施工安装
                </div>
                <div class="des-right">
                  <div class="straight">
                    <!-- list-nostar -->
                    <div
                      v-for="(item, index) in caseDetail.arrBuild"
                      :key="index"
                    >
                      <img
                        v-if="item == 'list-star'"
                        src="~@/assets/images/ant/details/star_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-nostar'"
                        src="~@/assets/images/ant/details/nostar_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-one'"
                        src="~@/assets/images/ant/details/xing_1.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-two'"
                        src="~@/assets/images/ant/details/xing_2.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-three'"
                        src="~@/assets/images/ant/details/xing_3.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-four'"
                        src="~@/assets/images/ant/details/xing_4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    {{
                      caseDetail.build == 0
                        ? "暂未评分"
                        : caseDetail.build
                        ? caseDetail.build + "分"
                        : ""
                    }}
                  </div>
                </div>
              </li>
              <li class="design-list">
                <div class="designthree">
                  <div class="designthree_bef"></div>
                  客户经理
                </div>
                <div class="des-right">
                  <div class="straight">
                    <!-- list-nostar -->
                    <div
                      v-for="(item, index) in caseDetail.arrManager"
                      :key="index"
                    >
                      <img
                        v-if="item == 'list-star'"
                        src="~@/assets/images/ant/details/star_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-nostar'"
                        src="~@/assets/images/ant/details/nostar_icon.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-one'"
                        src="~@/assets/images/ant/details/xing_1.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-two'"
                        src="~@/assets/images/ant/details/xing_2.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-three'"
                        src="~@/assets/images/ant/details/xing_3.png"
                        alt=""
                      />
                      <img
                        v-if="item == 'list-four'"
                        src="~@/assets/images/ant/details/xing_4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    {{
                      caseDetail.manager == 0
                        ? "暂未评分"
                        : caseDetail.manager
                        ? caseDetail.manager + "分"
                        : ""
                    }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 用户评论 -->
        <div
          class="comment"
          :style="{
            height: caseDetail.comments.length > 2 ? '' : 'auto',
          }"
          v-if="caseDetail.comments.length != 0"
        >
          <!-- <pull-to
          :top-load-method="downRefresh"
          :bottom-load-method="upRefresh"
          :is-bottom-bounce="true"
          bottom-block-height:0
          top-block-height:0
        > -->
          <ul>
            <li v-for="(item, index) in caseDetail.comments" :key="index">
              <div class="top-info">
                <div class="right">
                  <div class="img">
                    <img :src="item.headimgurl" alt="" />
                  </div>
                  <div>{{ item.nickname }}</div>
                </div>
                <div class="time">{{ item.created_at }}</div>
              </div>
              <div class="text" v-html="item.content"></div>
              <div class="user-img" v-if="item.images.length">
                <div
                  class="item-img"
                  v-for="(imgitem, imgindex) in item.images"
                  :key="imgindex"
                >
                  <img
                    :src="imgitem.img_resize"
                    @click="lookImg(item.images, imgindex)"
                    alt=""
                  />
                </div>
              </div>
            </li>
          </ul>
          <!-- </pull-to> -->
        </div>
      </div>
      <!-- 方案设计 -->
      <div class="plan" v-if="false">
        <div class="plan-top">
          <div class="title">方案设计</div>
          <div class="right-see">查看更多</div>
        </div>
        <div class="plan-img">
          <img v-lazy="" alt="" />
          <img v-lazy="" alt="" />
        </div>
      </div>
      <!-- 工程看板 -->
      <div class="storyboard">
        <div class="title">案例详情</div>
        <!-- <div class="storyboard-list">
          <div class="list-title">
            <div class="list-title-bef"></div>
            方案设计
          </div>
          <div class="other">
            <div class="list-warp">
              <div class="help">
                {{ caseDetail.design_desc }}
              </div>
              <div class="sysCase">
                <div>
                  <div class="sys_title">3D设计方案</div>
                  <div class="lookBtn" @click="goSysCase">点击查看</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div
          class="storyboard-list"
          v-for="(sumitem, sumindex) in caseDetail.items"
          :key="sumindex"
          v-show="caseDetail.items.length"
        >
          <div class="list-title" :id="'navTo' + sumindex">
            <div class="list-title-bef"></div>
            {{ sumitem.title }}
          </div>
          <div class="other">
            <div
              class="list-warp"
              v-for="(sonitem, sonindex) in sumitem.lists"
              :key="sonindex"
            >
              <div class="list-top-title">
                <div class="tipes">{{ sonitem.title }}</div>
                <div class="datetime">完工时间：{{ sonitem.finish_date }}</div>
              </div>
              <div class="help">{{ sonitem.desc }}</div>
              <!-- <div class="datetime">
              <div>开工时间：{{ sonitem.start_date }}</div>
              <div>完工时间：{{ sonitem.finish_date }}</div>
            </div> -->
              <div class="storyboard-img">
                <div
                  class="soffimg"
                  v-for="(imgitem, imgindex) in sonitem.images"
                  :key="imgindex"
                  :class="imgitem.nClass"
                >
                  <!-- @click="lookImg(sonitem.arrLookImg, imgindex)" -->
                  <img :src="imgitem.img_resize" alt="" />
                  <img
                    class="lookImg"
                    preview="1"
                    :src="imgitem.url"
                    alt=""
                    style=""
                  />
                </div>
                <!-- <vue-preview :slides="sonitem.arrLookImg" class="soffimg"></vue-preview> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ao  logo -->
      <div class="logo_img">
        <img src="@/assets/images/ant/details/logoone_icon.png" alt="" />
      </div>
    </div>
    <elPropress :bShowPropress="bShowPropress" :nRate="nRate"></elPropress>
  </div>
</template>
<script>
import elPropress from "@/components/propress/index";
import PullTo from "vue-pull-to";
import detail from "@/js/detail.js";
import { Toast } from "mint-ui";
import share from "./components/share/index";
import wxshare from "./components/wxshare/index";
import html2canvas from "html2canvas";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getWxSingleConfig, wxShareH5, qyWxShareH5 } from "@/js/wx.js";
let OSS = require("ali-oss");
let progressTime = null;
export default {
  components: {
    Toast,
    PullTo,
    share,
    wxshare,
    swiper,
    swiperSlide,
    elPropress,
  },
  data() {
    const vm = this;
    return {
      bShowPropress: true, //经度条是否显示
      nRate: 0,
      bSceat: true,
      bShowNrom: false, //分享弹窗
      bAtveat: false,
      cateIndex: 0, //目录
      nUserid: "", //用户id
      arrSwiperImg: [], //需要查看的图片
      bSwiper: false, //显示图片查看器
      bShowTips: false,
      caseDetail: {
        comments: [],
      }, //详情
      nPin: false, //判断是否评分
      contractText: "", //状态
      //轮播图配置
      showSwiper: false, //预览图片
      swiperIndex: 0,
      confit: {}, //分享配置
      bBottom: true,
      bChecked: false,
      bAgree: false,
      objSmcode: {},
      arrImg: [],
      count: 0,
    };
  },
  mounted() {
    let that = this;
    $init(() => {
      //案例id
      let user_id = that.$storage.getStorage("user_id");
      this.nUserid = user_id;
      let caseId = that.$route.query.id;
      let userId = that.$route.query.userId;
      if (userId != undefined) {
        this.bSceat = false;
        let detailData = {
          from_id: userId,
          project_id: caseId,
        };
        detail.getShareRen(detailData).then((res) => {
          //  console.log(res);
        });
      }
      this.$store.commit("loadSwitch", true);
      that.getProject(caseId);
    });
  },
  methods: {
    //点击查看3D设计方案
    goSysCase() {
      window.location.href = this.caseDetail.design_url;
    },
    //生成长图
    htmlToImage() {
      // console.log('父')
      let that = this;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let sHeight = document.querySelector(".share_center").offsetHeight - 70;
      let sWidth = document.querySelector(".share_center").offsetWidth;
      let scale = 2;
      this.$store.commit("loadSwitch", true);
      html2canvas(that.$refs.shareWrap, {
        useCORS: true,
        // backgroundColor:null,
        height: sHeight,
        width: sWidth,
        dpi: window.devicePixelRatio,
        scale: scale,
      })
        .then((canvas) => {
          let sUrl = canvas.toDataURL("image/png");
          this.getOssSts(sUrl);
          // console.log(sUrl);
        })
        .catch((fail) => {
          Toast({
            message: "生成长图失败",
            duration: 1200,
          });
          //  console.log(fail);
        });
      // console.log("长图", sHeight, sWidth);
    },
    // 获取oss配置
    async getOssSts(sUrl) {
      let oOssData = await detail.getOsssts({
        ext: "png",
      });
      let oOss = oOssData.result;
      //  console.log("加密数据", oOssData);
      let sKey = `tbzIwry9lT0qU81m${oOss.timestamp}`;
      // let oOssDecrypt = this.decrypt(sKey, oOss.body);
      // console.log('需要上传的图片',sUrl)
      let oFile = await this.base64ToLife(sUrl, oOss.key);
      this.ossUploadImg(oOss, oFile);
    },
    // base64 转 Blod
    base64ToLife(dataurl, filename) {
      return new Promise((resolve, reject) => {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blod = new Blob([u8arr], { type: mime });
        // blod.lastModifiedDate = new Date();
        // blod.name = filename;
        resolve(blod);
      });
    },
    // 上传图片到oss
    async ossUploadImg(oOss, oFile) {

      let client = new OSS({
        region: oOss.sts.region,
        bucket: oOss.sts.bucket,
        accessKeyId: oOss.sts.access_key_id,
        accessKeySecret: oOss.sts.access_key_secret,
        endpoint: oOss.sts.endpoint_internal,
        stsToken: oOss.sts.security_token,
        //cname: true,
        // timeout:30,
        secure: true,
      });
      try {
        //  console.log(oOss.object_name, oFile);
        client
          .multipartUpload(oOss.object_name, oFile)
          .then((res) => {
            //  console.log(res);
            let sFileName = res.name;
            this.savePoster(oOss.filename); //保存海报
          })
          .catch((err) => {
            //  console.log("错误信息", err);
          });
      } catch (e) {
        //  console.log(e);
      }
    },
    async savePoster(sFileName) {
      let oData = {
        image_url: sFileName,
      };
      let oSavePoster = await detail.getPoster(oData);
      let nPosterId = oSavePoster.result;
      //  console.log(nPosterId);
      // debugger
      // this.nRate = 100;
      clearInterval(progressTime);
      setTimeout(() => {
        //  console.log(nPosterId);
        // wx.miniProgram.redirectTo({
        //     url: `/pages/case/poster/index?nId=${nPosterId}`
        // });
        this.$router.replace({ path: `/antshare/index?nId=${nPosterId}` });
        this.$store.commit("loadSwitch", false);
      }, 1000);
    },
    //计算星星，展示数据
    itemClasses(nscore) {
      let that = this;
      let result = []; // 返回的是一个数组,用来遍历输出星星
      let score = (nscore * 2) / 2; // 计算所有星星的数量
      let hasDecimal = score % 1 !== 0; // 非整数星星判断
      let hasIndex = score.toString().split(".")[1];

      let integer = Math.floor(score); // 整数星星判断
      for (let i = 0; i < integer; i++) {
        // 整数星星使用on
        result.push("list-star"); // 一个整数星星就push一个CLS_ON到数组
      }
      if (hasDecimal) {
        if (hasIndex == 1 || hasIndex == 2) {
          result.push("list-one");
        } else if (hasIndex == 3 || hasIndex == 4) {
          result.push("list-two");
        } else if (hasIndex == 5 || hasIndex == 6) {
          result.push("list-three");
        } else if (hasIndex == 7 || hasIndex == 8) {
          result.push("list-four");
        } else if (hasIndex == 9) {
          result.push("list-star");
        }
        //  console.log("1", hasDecimal);
        // 非整数星星使用half // 类似
      }
      while (result.length < 5) {
        // 余下的用无星星补全,使用off
        result.push("list-nostar");
      }
      return result;
    },
    //加载图片
    getImages(arrImage) {
      let that = this;
      // for (let img of arrImage) {
      let image = new Image();
      image.src = this.arrImg[that.count];
      image.onload = () => {
        that.count++;
        // 计算图片加载的百分数，绑定到percent变量
        let percentNum = Math.floor((that.count / this.arrImg.length) * 100);
        // this.percent = `${percentNum}%`;
        that.nRate = percentNum;
        if (that.count == this.arrImg.length) {
          //  console.log(percentNum);
          setTimeout(() => {
            // that.bShowPropress = false;
            that.htmlToImage();
          }, 500);
        } else {
          that.getImages();
        }
      };
      image.onerror = () => {
        // this.bShowBtn = true;
        Toast({
          message: "加载图片失败",
          duration: 1200,
        });
      };
      // }
    },
    //项目详情
    getProject(id) {
      let that = this;
      let detailData = {
        project_id: id,
      };
      detail.getDetail(detailData).then((res) => {
        this.$store.commit("loadSwitch", false);
        // debugger
        let caseDetail = res.result;
        //  console.log("-->", res);
        if (
          caseDetail.project_design == 0 &&
          caseDetail.build == 0 &&
          caseDetail.manager == 0
        ) {
          this.nPin = true;
        } else {
          this.nPin = false;
        }
        let hourTime = new Date(
          caseDetail.created_at.replace(/\-/g, "/")
        ).getTime();
        // comments
        //  console.log("items", caseDetail.items);
        if (caseDetail.items.length) {
          caseDetail.items.forEach((it) => {
            it.lists.forEach((bt) => {
              bt.images.forEach((ig) => {
                if (ig.img_resize != "") {
                  this.arrImg.push(ig.img_resize);
                }
              });
            });
          });
        }
        if (caseDetail.comments.length) {
          caseDetail.comments.forEach((it) => {
            // console.log("-->", it);
            it.images.forEach((ig) => {
              if (ig.img_resize != "") {
                this.arrImg.push(ig.img_resize);
              }
            });
          });
        }
        that.getImages(this.arrImg);
        //  console.log(this.arrImg);
        // debugger
        let formatTime = that.formatDateTime(hourTime);
        caseDetail.arrDesign = that.itemClasses(caseDetail.project_design); //方案设计
        caseDetail.arrBuild = that.itemClasses(caseDetail.build); //施工安装
        caseDetail.arrManager = that.itemClasses(caseDetail.manager); //客户经理
        // console.log('方案设计',that.arrDesign,'施工安装',that.arrBuild,'客户经理',that.arrManager)
        switch (caseDetail.state) {
          case 1:
            that.contractText = "已签约";
            break;
          case 2:
            that.contractText = "施工中";
            break;
          case 3:
            that.contractText = "已完工";
            break;
        }
        caseDetail.formatTime = formatTime;
        that.caseDetail = caseDetail;
        this.$forceUpdate();
        //  console.log(caseDetail);
      });
    },
    /**
     * 格式化时间
     */
    //时间戳转化为yy-mm-dd
    formatDateTime(timeStamp) {
      var date = new Date();
      date.setTime(timeStamp);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "/" + m + "/" + d;
    },
  },
};
</script>
<style lang="scss" scoped>
.agree {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.637);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .agree_warp {
    width: 80%;
    height: calc(100vh - 100px);
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .agree_title {
      font-weight: 700;
      font-size: 38px;
      text-align: center;
      margin-bottom: 20px;
    }
    .content_agree {
      width: 100%;
      height: calc(100vh - 410px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
        color: transparent !important;
        display: none;
      }
    }
    .consent {
      display: flex;
      align-items: center;
      margin-top: 20px;
      input {
        width: 40px;
        height: 40px;
        -webkit-appearance: button !important;
        margin-right: 10px;
      }
    }
    .btn {
      width: 450px;
      height: 85px;
      background-color: #2c7aec;
      border-radius: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      color: #fff;
      margin: 20px auto 0;
    }
  }
}
.logo_img {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 70%;
    // margin: 0 auto;
    margin-top: 20px;
  }
}
@import "index.scss";
</style>
